// Items in a folder shared with the user come as "<owner zid>:<id>"
const SHARED_ID = /^(.+):(-?\d+)$/;
const sharedParts = id => (id == null ? null : String(id).match(SHARED_ID));

const idFixer = id => {
  if (id === null) return null;
  const shared = sharedParts(id);
  return shared
    ? `${shared[1]}:${Math.abs(shared[2])}`
    : parseInt(Math.abs(id));
};

// The id as parseInt reads it, but a shared item's id is kept whole
export const toId = id => (sharedParts(id) ? String(id) : parseInt(id));

// Conversations have positive ids, single messages negative ones
export const isConversationId = id => {
  const shared = sharedParts(id);
  return (shared ? Number(shared[2]) : id) > 0;
};

export const idEncode = (id, order = 0, sepeartor = "|") =>
  `${id}${sepeartor}${order}`;
export const idDecode = (id, order = 0, sepeartor = "|") =>
  id?.toString()?.split(sepeartor)?.[order];
export const isIdEncoded = (id, sepeartor = "|") =>
  !!id?.toString()?.includes(sepeartor);

export default idFixer;
